import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl, pickupId, CountryTxt } from "../../Helpers/Config";
import {
  hideLoader,
  showAlert,
  showPriceValue,
  showDateTime,
  addressFormat,
  showDate,
  showOrderTime
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";

var module = "order";
var moduleName = "Order Details";
var modulePath = "/clientpanel/order/";
class Details extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, 'this.propsthis.propsthis.props')
    const editID = this.props.params?.orderID || "";
    const order_type = this.props.params?.orderType || "";
    
    this.state = {
      editID: editID,
      order_type: order_type,
      order_details: [],
      pageloading: true,
    };
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        url: `${ecommerceapiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg =
          nextProps.formpost[0].form_error !== ""
            ? nextProps.formpost[0].form_error
            : nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          this.setState({ order_details: result, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          showAlert("Error", "Invalid Order", "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {};

  render() {
    var order = this.state.order_details;
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={this.state.order_type} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath + this.state.order_type}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                {Object.keys(this.state.order_details).length > 0 && (
                  <div className="card invoice-preview-card">
                    <ul className="list-group fw-bold">
                      <li
                        className={
                          "list-group-item text-end list-group-item-" +
                          (() => {
                            if (order.orderStatus === 1) {
                              return "primary";
                            } else if (order.orderStatus === 2) {
                              return "warning";
                            } else if (order.orderStatus === 3) {
                              return "info";
                            } else if (order.orderStatus === 4) {
                              return "success";
                            } else if (order.orderStatus === 5) {
                              return "danger";
                            }
                          })()
                        }
                        style={{
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0,
                        }}
                      >
                        {order.orderAvailabilityID === pickupId && order.orderStatus === 3
                            ? "Ready to pickup"
                            : (() => {
                              if (order.orderStatus === 1) {
                                return "Received";
                              } else if (order.orderStatus === 2) {
                                return "Processing";
                              } else if (order.orderStatus === 3) {
                                return "Delivering";
                              } else if (order.orderStatus === 4) {
                                return "Completed";
                              } else if (order.orderStatus === 5) {
                                return "Cancelled";
                              }
                            })()
                          }
                      </li>
                    </ul>
                    <div className="card-body">
                      <div className="d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column">
                        <div className="mb-xl-0 pb-3">
                          {order.orderStatus === 5 && (
                            <div className="d-flex svg-illustration align-items-center gap-2 mb-4">
                              <span className="fw-bold">Cancel Remarks:</span>
                              {order.orderCancelRemarks}
                            </div>
                          )}
                          <div className="d-flex svg-illustration align-items-center gap-2 mb-4">
                            <span className="h4 mb-0 app-brand-text fw-bold">
                              {order.orderAvailabilityName}
                            </span>
                          </div>
                          <p className="mb-1">{order.orderCustomerFirstName}{order.orderCustomerLastName}</p>
                          <p className="mb-1">
                            <a
                              href={
                                "mailto:" + order.orderCustomerEmail
                              }
                            >
                              {order.orderCustomerEmail}
                            </a>
                          </p>
                          <p className="mb-0">
                            <a
                              href={
                                "tel:" + order.orderCustomerMobile
                              }
                            >
                              {order.orderCustomerMobile}
                            </a>
                          </p>
                          <p className="mb-0">
                            <span className="fw-semibold">Order Source: </span>{" "}
                            {order.orderSource}
                          </p>
                        </div>
                        <div>
                          <h5 className="fw-bold">
                            Order Number #{order.orderNumber}
                          </h5>
                          <div className="mb-1">
                            <span>{order.orderAvailabilityName} Date: </span>
                            <span className="fw-bold">
                              {showDate(order.orderDate)} &nbsp; {showOrderTime(order.orderDate, order.orderSlotStart, order.orderSlotEnd, order.orderDateType)}
                            </span>
                          </div>
                          <div>
                            <span>Order Created Date: </span>
                            <span className="fw-bold">
                              {showDateTime(order.createdAt)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="card-body">
                    {order.orderAvailabilityName === "Delivery" && (
                      <>
                      <div className="d-flex justify-content-between flex-wrap">
                        <div className="my-3">
                          <h6 className="pb-2 fw-bold">Delivery Address:</h6>
                          <p className="mb-1">{order.orderCustomerFirstName}{order.orderCustomerLastName}</p>
                          <p className="mb-1">
                            {addressFormat(
                              order?.orderDeliveryUnitNumber?? '',
                              order?.orderDeliveryFloorNumber ?? '',
                              order?.orderDeliveryAddress ?? '',
                              order?.orderDeliveryPostalCode ?? '',
                              CountryTxt
                            )}
                          </p>
                        </div>                        
                        <div className="my-3">
                          <h6 className="pb-2 fw-bold">Bill Address:</h6>
                          <p className="mb-1">
                          {addressFormat(
                            order?.orderBillingUnitNumber?? '',
                            order?.orderBillingFloorNumber ?? '',
                            order?.orderBillingAddress ?? '',
                            order?.orderBillingPostalCode ?? '',
                            CountryTxt
                          )}
                          </p>
                        </div>
                      </div>                      
                      <div className="my-3">
                        <h6 className="pb-2 fw-bold">Rider Details:</h6>
                        <p className="mb-1">
                          <b>Driver Reference Number :</b>{" "}
                          {order.orderDriverID !== "" ? order.orderDriverID
                            : "N/A"}
                        </p>
                        <p className="mb-1">
                          <b>Driver Name :</b>{" "}
                          {order.orderDriverName !== "" ? order.orderDriverName : "N/A"}
                        </p>
                        <p className="mb-1">
                          <b>Driver Phone :</b>{" "}
                          {order.orderDriverPhone !== "" ? order.orderDriverPhone : "N/A"}
                        </p>
                      </div>
                      </>
                      )}
                    </div>
                    <div className="table-responsive">
                      <table className="table m-0">
                        <thead className="table-light border-top">
                          <tr>
                            <th>Item Name</th>
                            <th>Combo Details</th>
                            <th width="150" className="text-end">
                              Cost
                            </th>
                            <th width="100">Qty</th>
                            <th width="150" className="text-end">
                              Price
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {order.orderItem.length > 0 &&
                            order.orderItem.map((item1, index1) => {
                              return (
                                <tr key={index1}>
                                  <td
                                    className="text-nowrap"
                                    valign="top"
                                  >
                                    <span className="fw-semibold">
                                      {item1.orderItemProductName}
                                    </span>
                                    {item1.orderItemNote !== "" && (
                                        <i>
                                          <br />
                                          {item1.orderItemNote}
                                        </i>
                                      )}
                                  </td>
                                  <td className="text-nowrap">
                                    {item1.orderItemComboSet.length > 0 && (
                                      <ul className="list-unstyled">
                                        {item1.orderItemComboSet.map((comob, comboIndex) => {
                                            return (
                                              <li
                                                className="mb-3"
                                                key={comboIndex}
                                              >
                                                <i className="mdi mdi-chevron-right scaleX-n1-rtl text-muted me-1"></i>
                                                <span className="fw-semibold">
                                                  {comob.comboName}
                                                </span>
                                                {comob.products.length > 0 && (
                                                  <ul className="list-unstyled mx-4">
                                                    {comob.products.map((comobItem, comobItemIndex) => {
                                                        return (
                                                          <li key={comobItemIndex}>
                                                            <i className="mdi mdi-chevron-right scaleX-n1-rtl text-muted me-1"></i>
                                                            {comobItem.productName}{" "}
                                                            X{" "}
                                                            {comobItem.productQuantity}
                                                            {parseFloat(comobItem.productPrice) > 0
                                                              ? "(" +
                                                                showPriceValue(comobItem.productPrice) +
                                                                ")"
                                                              : ""}
                                                          </li>
                                                        );
                                                      }
                                                    )}
                                                  </ul>
                                                )}
                                              </li>
                                            );
                                          }
                                        )}
                                      </ul>
                                    )}
                                  </td>
                                  <td className="text-end" valign="top">
                                    {showPriceValue(item1.orderItemPrice)}
                                  </td>
                                  <td valign="top">{item1.orderItemQuantity}</td>
                                  <td className="text-end" valign="top">
                                    {showPriceValue(item1.orderItemTotalPrice)}
                                  </td>
                                </tr>
                              );
                            })}
                            {order.orderAdditionalInformation !== null && order.orderAdditionalInformation !== "" && (
                              <tr>
                                <td colSpan={4}>
                                  <strong>Note:</strong>
                                  {order.orderAdditionalInformation}
                                </td>
                              </tr>
                            )}
                         
                          <tr>
                            <td className="align-top px-4 py-5">
                              <p className="mb-2">
                                <span className="me-1 fw-semibold">
                                  Payment Method:
                                </span>
                                <span>{order.orderPaymentMode}</span>
                              </p>
                              {order.orderPaymentMode !== "COD" && (
                                <>
                                  <p className="mb-2">
                                    <span className="me-1 fw-semibold">
                                      Payment Gateway:
                                    </span>
                                    <span>
                                      {order.orderPaymentGetwayName}
                                    </span>
                                  </p>
                                  <p className="mb-2">
                                    <span className="me-1 fw-semibold">
                                      Payment Reference No.:
                                    </span>
                                    <span>{order.orderPaymentReferenceID}</span>
                                  </p>
                                  <p className="mb-2">
                                    <span className="me-1 fw-semibold">
                                      Payment Status:
                                    </span>
                                    <span>
                                      {order.orderPaymentStatus}
                                    </span>
                                  </p>
                                </>
                              )}
                              {/* order.orderAvailabilityName === "Delivery" && (
                                <>
                                {order.order_delivary_type !== "" && (
                                  <p className="mb-2">
                                    <span className="me-1 fw-semibold">
                                      Delivery Details:
                                    </span>
                                    <span>{order.order_delivary_type}</span>
                                  </p>
                                )}
                                {order.order_driver_ref_id !== "" && (
                                  <p className="mb-2">
                                    <span className="me-1 fw-semibold">
                                      Delivery Reference No.:
                                    </span>
                                    <span>{order.order_driver_ref_id}</span>
                                  </p>
                                )}
                                {order.order_driver_name !== "" && (
                                  <p className="mb-2">
                                    <span className="me-1 fw-semibold">
                                      Delivery Driver Name:
                                    </span>
                                    <span>{order.order_driver_name}</span>
                                  </p>
                                )}
                                {order.order_driver_phone !== "" && (
                                  <p className="mb-2">
                                    <span className="me-1 fw-semibold">
                                      Delivery Driver Phone:
                                    </span>
                                    <span>{order.order_driver_phone}</span>
                                  </p>
                                )}
                                </>
                              ) */}
                            </td>
                            <td
                              colSpan="2"
                              className="text-end px-4 py-5"
                              valign="top"
                            >
                              {parseFloat(order.orderSubTotal) > 0 && (
                                <p className="mb-2">Subtotal:</p>
                              )}
                              {parseFloat(order.orderDeliveryCharge) > 0 && (
                                <p className="mb-2">Delivery Charge:</p>
                              )}
                              {order.orderadditionalChargeList.length>0 && (
                                order.orderadditionalChargeList.map((item, index)=> {
                                  return(<p className="mb-2" key={index}>{item.title}:</p>)
                                })
                              )}
                              {parseFloat(order.orderDiscount) > 0 && (
                                <p className="mb-2">Discount({order.orderPromoCode}):</p>
                              )}
                              {parseFloat(order.orderUsedPoints) > 0 && (
                                 <p className="mb-2">Redeemed Points({parseFloat(order.orderUsedPoints)})</p>
                              )}
                              {parseFloat(order.orderUsedAscentisPoints) > 0 && (
                                 <p className="mb-2">Redeemed Points({parseFloat(order.orderUsedAscentisPoints)})</p>
                              )}
                              {(parseFloat(order.orderTaxAmount) > 0) && (
                                <p className="mb-2">
                                  {order.orderTaxType ? `${order.orderTaxType} GST`
                                    : "GST"}
                                  ({order.orderTaxPercentage}%):
                                </p>
                              )}
                              <p className="mb-0">Total:</p>
                            </td>
                            <td
                              className="px-4 py-5"
                              colSpan={"2"}
                              valign="top"
                            >
                              {parseFloat(order.orderSubTotal) > 0 && (
                                <p className="fw-semibold mb-2 text-end">
                                  {showPriceValue(order.orderSubTotal)}
                                </p>
                              )}{" "}
                              {parseFloat(order.orderDeliveryCharge) > 0 && (
                                <p className="fw-semibold mb-2 text-end">
                                  {showPriceValue(order.orderDeliveryCharge)}
                                </p>
                              )}
                              {order.orderadditionalChargeList.length>0 && (
                                order.orderadditionalChargeList.map((item, index)=> {
                                  return(<p className="fw-semibold mb-2 text-end" key={index}>
                                  {showPriceValue(item.amount)}
                                </p>);
                                })
                              )}
                              {parseFloat(order.orderDiscount) > 0 && (
                                 <p className="fw-semibold mb-2 text-end">-{showPriceValue(order.orderDiscount)}</p>
                              )}
                              {parseFloat(order.orderUsedPointAmounts) > 0 && (
                                 <p className="fw-semibold mb-2 text-end">-{showPriceValue(order.orderUsedPointAmounts)}</p>
                              )}
                              {parseFloat(order.orderUsedAscentisPoints) > 0 && (
                                 <p className="fw-semibold mb-2 text-end">-{showPriceValue(order.orderUsedAscentisPoints)}</p>
                              )}
                              {(parseFloat(order.orderTaxAmount) > 0) && (
                                 <p className="fw-semibold mb-2 text-end">
                                  {showPriceValue(order.orderTaxAmount)}
                                </p>
                              )}
                              <p className="fw-semibold mb-2 text-end">
                                {showPriceValue(order.orderGrandTotal)}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-12"></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Details));
